
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
//import { isObjectEmpty } from '../../utils';
import { withStyles } from '@material-ui/core/styles';
import { documentStyles } from '../../Styles/documentStyles';
import Images from '../../Theme/Images';
import DocumentNavbar from './DocumentNavbar';
import { ReactSVG } from 'react-svg'
//import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import Loader from 'react-loader-spinner'
import DocumentDrawer from './DocumentDrawer';
import Rector from './Rector'
import DocumentForm from './DocumentForm';
import { SizeMe } from 'react-sizeme'

@inject('documentStore', 'imageStore')
@observer
class CurrentDocument extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            resetImage: false
        }
        this._areaElement = new Map();
        this._areaElementBack = new Map();
    }

    componentDidMount() {
       /* if (this.props.location.pathname.toLowerCase().split("/document/")[1])
            this.props.documentStore.getDocumentDetails(this.props.location.pathname.toLowerCase().split("/document/")[1])
        else if (this.props.location.documentId === undefined)
            this.props.history.push('/dashboard/drafts')*/
        this.props.documentStore.getDocumentDetails(this.props.match.params['documentId']);
        this.props.documentStore.closeDocumentDrawer()
    }

    highlight = (event, index) => {
        const { currentPage } = this.props.documentStore;
        this.fitPage()
        this.resetHighlight(false)
        const node = this._areaElement.get(index);
        const { currentWidthImage, getAspectRatio } = this.props.imageStore;
        const imgHeight = currentWidthImage * getAspectRatio;

        /* if (node.props.newlyCreated) {
             this.props.documentStore.startDrawPoint(currentPage.formData[0],
                 currentPage.formData[1], currentPage.formData[2],
                 currentPage.formData[3], { width: currentWidthImage, height: imgHeight }, currentPage.formData, { w: currentWidthImage, h: imgHeight });
         } else {
        this.setState({
            pointX: currentPage.formData[0].pts * currentWidthImage,
        }) */
        this.props.imageStore.zoomIn();
        this.props.imageStore.startDrawPoint(currentPage.formData[index].pts[0] * currentWidthImage,
            currentPage.formData[index].pts[1] * imgHeight,
            currentPage.formData[index].pts[2] * currentWidthImage - currentPage.formData[index].pts[0] * currentWidthImage,
            currentPage.formData[index].pts[3] * imgHeight - currentPage.formData[index].pts[1] * imgHeight,
            { width: currentWidthImage - currentPage.formData[index].pts[0] * currentWidthImage, height: imgHeight - currentPage.formData[index].pts[1] * imgHeight }, currentPage.formData[index].pts,
            { w: currentWidthImage, h: imgHeight });
        //}
    }

    highlightBack = (event, index) => {
        const { currentPage } = this.props.documentStore
        this.resetHighlight(false)
        const node = this._areaElementBack.get(index);
        const { currentWidthImage, getAspectRatioBack } = this.props.imageStore;
        const imgHeight = currentWidthImage * getAspectRatioBack;

        if (node.props.newlyCreated) {
            this.props.imageStore.startDrawPoint(currentPage.formData[index].pts[0],
                currentPage.formData[index].pts[1], currentPage.formData[index].pts[2],
                currentPage.formData[index].pts[3], { width: currentWidthImage, height: imgHeight }, currentPage.formData[index], { w: currentWidthImage, h: imgHeight });
        } else {
            this.props.imageStore.startDrawPoint(currentPage.formData[0] * currentWidthImage,
                currentPage.formData[index].pts[1] * imgHeight,
                currentPage.formData[index].pts[2] * currentWidthImage - currentPage.formData[index].pts[0] * currentWidthImage,
                currentPage.formData[index].pts[3] * imgHeight - currentPage.formData[index].pts[1] * imgHeight,
                { width: currentWidthImage, height: imgHeight }, currentPage.formData[index], { w: currentWidthImage, h: imgHeight }
            );
        }
    }

    resetHighlight(reset) {
        this.setState({
            resetImage: reset
        })
    }

    removeHighlight = (event, index) => {
        this.resetHighlight(true)
        const node = this._areaElement.get(index);
        this.props.imageStore.eraseDrawPoint();
    }

    openDropDown = () => {
        this.props.imageStore.openDocumentDrawer()
    }

    zoomIn = () => {
        if (this.props.documentStore.currentField._id !== undefined)
            this.props.imageStore.zoomIn()
    }

    zoomOut = () => {
        if (this.props.documentStore.currentField._id !== undefined)
            this.props.imageStore.zoomOut()
    }

    fitPage = () => {
        if (this.props.documentStore.currentField._id !== undefined)
            this.props.imageStore.fitPage()
    }

    render() {
        const { classes } = this.props;
        const { currentPage, currentDoc, inProgress, currentField } = this.props.documentStore;

        if (inProgress)
            return (
                <div className={classes.loaderDiv}><Loader height={100} width={100} color={this.props.theme.palette.blue} className={classes.loading} timeout={100000} /></div>
            )

        return (
            currentDoc.pageArray && currentDoc.pageArray.length ? <div>
                {currentDoc.docStatus === "REVIEW_PENDING" ? <DocumentDrawer></DocumentDrawer> : null}
                <div className={classes.content} style={{ display: 'flex' }}>
                    <DocumentForm resetImage={this.fitPage} highlight={this.highlight} removeHighlight={this.removeHighlight}></DocumentForm>
                    <div className={classes.imageDiv}>
                        <SizeMe>{({ size }) =>
                            <div className={classes.imageContainer} id="rector-container">
                                <Rector resetImage={false} imageContainerWidth={size.width} imageContainerHeight={currentPage.dimension.aspectRatio * (size.width)}
                                    width={currentPage.dimension.width} height={currentPage.dimension.height}
                                    aspectRatio={currentPage.dimension.aspectRatio} imageSrc={currentPage.pageImageLink} onSelected={this.onSelected} />
                                <div className={classes.pageNo}>
                                    Page {currentPage.pageNo}
                                </div>
                                {currentField._id !== undefined ?
                                    <div className={classes.zoomContainer}>
                                        <ReactSVG
                                            beforeInjection={svg => {
                                                svg.classList.add(classes.svg)
                                            }}
                                            onClick={(e) => this.zoomIn()}
                                            src={Images.zoomIn} />
                                        <ReactSVG
                                            beforeInjection={svg => {
                                                svg.classList.add(classes.svg)
                                            }}
                                            onClick={(e) => this.zoomOut()}
                                            src={Images.zoomOut} />
                                        <ReactSVG disabled
                                            beforeInjection={svg => {
                                                svg.classList.add(classes.svg)
                                            }}
                                            onClick={(e) => this.fitPage()}
                                            src={Images.fitPage} />
                                    </div> : null}
                            </div>
                        }</SizeMe>
                    </div>
                </div>
                <DocumentNavbar resetImage={this.fitPage}></DocumentNavbar>
            </div> : null

        )
    }
}
export default withStyles(documentStyles, { withTheme: true })(withRouter(CurrentDocument));
